var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeImageBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3061.91,
    height: 2728.07,
    viewBox: "0 0 3061.91 2728.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FLOOR"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2959.51,
    y1: 2671.47,
    x2: 0.11,
    y2: 2671.47,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.61,
    y1: 2725.07,
    x2: 1953.31,
    y2: 2725.07,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "TABLE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2807,2006.37h-473.3a40.63,40.63,0,0,0-40.6,40.6v624.5h554.4V2047A40.48,40.48,0,0,0,2807,2006.37Z",
    fill: "#d0f0e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2807,2006.37h-473.3a40.63,40.63,0,0,0-40.6,40.6v624.5h554.4V2047A40.48,40.48,0,0,0,2807,2006.37Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2229.31,
    y: 1304.77,
    width: 683,
    height: 1366.6,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2930.21 1133.67 587.91 1133.67 587.91 1304.77 3061.91 1304.77",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2807,1626h-472.4a40.63,40.63,0,0,1-40.6-40.6v-166.8a40.63,40.63,0,0,1,40.6-40.6H2807a40.63,40.63,0,0,1,40.6,40.6v166.9A40.54,40.54,0,0,1,2807,1626Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2807,1928h-472.4a40.63,40.63,0,0,1-40.6-40.6v-166.8a40.63,40.63,0,0,1,40.6-40.6H2807a40.63,40.63,0,0,1,40.6,40.6v166.8A40.63,40.63,0,0,1,2807,1928Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2572.41,
    cy: 1499.87,
    r: 32.5,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2572.41,
    cy: 1802.77,
    r: 32.5,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "BACKET"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2775.31 2214.37 2774.61 2218.67 2774.31 2221.17 2763.91 2287.47 2763.91 2287.47 2762.81 2294.57 2762.81 2294.57 2758.11 2324.77 2756.41 2335.37 2756.41 2335.37 2752.01 2363.37 2750.91 2370.47 2740.21 2439.07 2740.21 2439.37 2739.11 2446.47 2738.51 2449.67 2728.31 2515.27 2727.21 2522.37 2727.21 2522.37 2722.41 2553.27 2722.41 2553.37 2720.71 2563.97 2716.41 2591.17 2716.41 2591.17 2715.31 2598.27 2704.61 2667.17 2704.51 2667.57 2704.51 2667.57 2704.01 2670.77 2703.91 2671.47 2422.91 2671.47 2422.81 2670.67 2422.31 2667.87 2422.21 2666.97 2422.21 2666.97 2411.41 2598.17 2410.31 2590.97 2406.11 2564.27 2404.51 2553.57 2399.61 2522.17 2398.51 2515.07 2388.31 2449.97 2387.71 2446.27 2386.61 2439.27 2386.61 2439.17 2375.81 2370.27 2374.71 2363.17 2370.41 2335.67 2368.81 2325.07 2364.01 2294.37 2362.91 2287.27 2352.61 2221.47 2351.51 2214.37 2775.31 2214.37",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2706.61,2674.57h-286.4l-1.2-7.4-71.2-455.9h431.1Zm-281.1-6.2h275.7l70.4-450.8H2355Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2779.21,2214.37a12.91,12.91,0,0,1-.7,4.3c-3.4,10.5-19,20.2-43.5,28.2-1.8.6-3.6,1.1-5.4,1.7a402.16,402.16,0,0,1-56,11.9l-6.1.9c-18.8,2.6-39.3,4.5-61,5.6l-6.5.3c-11.9.5-24.2.8-36.7.8-9.6,0-19.1-.2-28.4-.5l-6.9-.3c-25-1-48.6-3.1-70-6.1-2.6-.4-5.1-.7-7.6-1.1-36.3-5.5-65.5-13.6-83.4-23.3-10.4-5.6-16.9-11.7-19-18.1l-.6-4.2c0-29.6,96.6-53.5,215.8-53.5,118.5,0,214.7,23.7,215.8,53.1C2779.21,2214.07,2779.21,2214.17,2779.21,2214.37Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2704.71,2667.27v4l-.7-.5-.1.6h-2.6l-31.9-41.2-3.3-4.3-32.1-41.4-3.3-4.3-32.1-41.4-3.3-4.3-32.1-41.4-3.3-4.3-32.1-41.4-3.3-4.3-32-41.4-3.3-4.3-32.1-41.4-3.3-4.3-32-41.4-3.3-4.3-32-41.4-3.3-4.3-30.7-39.6-.5-2.9c2,6.3,8.4,12.3,18.6,17.8l15.8,20.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3,31.9,41.2Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2716.41,2591.17h0l-1.1,7.1-10.6-13.7-3.3-4.3-32.1-41.4-3.3-4.3-32.1-41.4-3.3-4.3-32.1-41.4-3.3-4.3-32.1-41.4-3.3-4.3-31.8-41-3.3-4.3-32.1-41.4-3.3-4.3-32.1-41.4-3.3-4.3-1.4-1.8c2.4.4,4.9.7,7.4,1.1l.5.7,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2728.31,2515.27l-1.1,7.1-22.5-29-3.3-4.3-32.1-41.4-3.3-4.3-32.1-41.4-3.3-4.3-32.1-41.4-3.3-4.3-32.1-41.4-3.3-4.3-31.3-40.4,6.8.3,27.8,35.8,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2740.21,2439.37l-1.1,7.1-2.3-3-32.1-41.4-3.3-4.3-32.1-41.4-3.3-4.3-32.1-41.4-3.3-4.3-31.3-40.4,6.4-.3,28.2,36.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3,32.1,41.4Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2494.61 2669.87 2492.61 2671.37 2492.51 2671.47 2489.21 2671.47 2457.21 2630.27 2453.91 2625.97 2421.91 2584.57 2418.61 2580.37 2406.11 2564.27 2404.51 2553.57 2421.91 2576.07 2425.21 2580.37 2457.21 2621.67 2460.51 2625.97 2492.61 2667.37 2494.61 2669.87",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2423.81 2669.87 2422.81 2670.67 2422.31 2667.87 2423.81 2669.87",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2565.31 2669.87 2563.31 2671.37 2563.21 2671.47 2559.91 2671.47 2528.01 2630.27 2524.71 2625.97 2492.61 2584.57 2489.31 2580.37 2457.21 2538.97 2453.91 2534.77 2453.91 2534.67 2421.91 2493.37 2418.61 2489.07 2388.31 2449.97 2387.71 2446.27 2386.61 2439.27 2389.81 2443.47 2421.91 2484.87 2425.21 2489.07 2457.21 2530.47 2460.51 2534.77 2492.61 2576.07 2495.91 2580.37 2528.01 2621.67 2531.31 2625.97 2563.31 2667.37 2565.31 2669.87",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2636.01 2669.87 2634.01 2671.37 2633.91 2671.47 2630.61 2671.47 2598.71 2630.27 2595.41 2625.97 2563.31 2584.57 2560.01 2580.37 2528.01 2538.97 2524.71 2534.77 2492.61 2493.37 2489.31 2489.07 2457.21 2447.77 2453.91 2443.47 2421.91 2402.07 2418.61 2397.87 2386.51 2356.47 2383.21 2352.27 2370.41 2335.67 2368.81 2325.07 2386.51 2347.97 2389.81 2352.27 2421.91 2393.57 2425.21 2397.87 2457.21 2439.17 2460.51 2443.47 2492.61 2484.87 2495.91 2489.07 2528.01 2530.47 2531.31 2534.77 2563.31 2576.07 2566.61 2580.37 2598.71 2621.67 2602.01 2625.97 2634.01 2667.37 2636.01 2669.87",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2752,2363.37l-1.1,7.1-10.8-14-3.3-4.3-32.1-41.4-3.3-4.3-32.1-41.4-3.3-4.3-.4-.5c2-.3,4-.6,5.9-.9l1.1,1.4,32.1,41.4,3.3,4.3,32.1,41.4,3.3,4.3Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2763.91,2287.47h0l-1.1,7.1-22.7-29.3-3.3-4.3-10.1-13.1c1.8-.5,3.6-1.1,5.3-1.7l8.1,10.5,3.3,4.3Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2778.21,2216l-2.8,3.6-.8-1h0a12.34,12.34,0,0,0,.7-4.2v-.5l.1-.1Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2758.11 2324.77 2756.41 2335.37 2756.41 2335.37 2743.41 2352.27 2740.11 2356.47 2708.01 2397.87 2704.71 2402.07 2672.71 2443.47 2669.41 2447.77 2637.31 2489.07 2634.01 2493.37 2602.01 2534.77 2598.71 2538.97 2566.61 2580.37 2563.31 2584.57 2531.31 2625.97 2528.01 2630.27 2496.01 2671.47 2492.71 2671.47 2492.61 2671.37 2490.71 2669.87 2492.61 2667.37 2524.71 2625.97 2528.01 2621.67 2560.01 2580.37 2563.31 2576.07 2595.41 2534.77 2598.71 2530.47 2630.71 2489.07 2634.01 2484.87 2666.11 2443.47 2669.41 2439.17 2701.41 2397.87 2704.71 2393.57 2736.81 2352.27 2740.11 2347.97 2758.11 2324.77",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2774.31,2221.17l-30.9,39.9-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-31.9,41-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-31.9,41.2h-2.4l-.1-.8-.4-2.8-.4-.5.3-.4h0l31.8-41,3.3-4.3,32.1-41.4,3.3-4.3,32.1-41.4,3.3-4.3,32.1-41.4,3.3-4.3,32.1-41.4,3.3-4.3,32.1-41.4,3.3-4.3,32.1-41.4,3.3-4.3,32.1-41.4,3.3-4.3,32-41.4,3.3-4.3,15.7-20.3c10.3-5.5,16.8-11.5,18.9-17.9Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2674,2259.27l-1.4,1.8-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-10.5,13.5-1.1-7.1,8.3-10.7,3.3-4.3,32-41.4h0l3.3-4.3,32.1-41.4,3.3-4.3,32-41.4,3.3-4.3,32.1-41.4,3.3-4.3,32.1-41.4,3.3-4.3,32.1-41.4,3.3-4.3,32.1-41.4.5-.7c1.7-.2,3.4-.5,5-.7C2672.41,2259.47,2673.21,2259.37,2674,2259.27Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2597.91,2266.27l-31.3,40.3-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-22.3,28.8-1.1-7.1,20.1-26,3.3-4.3,32.1-41.4,3.3-4.3,32.1-41.4,3.3-4.3,32.1-41.4,3.3-4.3,32.1-41.4,3.3-4.3,27.8-35.8C2593.31,2266.47,2595.61,2266.37,2597.91,2266.27Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2722.41 2553.37 2720.71 2563.97 2708.01 2580.37 2704.71 2584.57 2672.71 2625.97 2669.41 2630.27 2637.41 2671.47 2634.11 2671.47 2634.01 2671.37 2632.11 2669.87 2634.01 2667.37 2666.11 2625.97 2669.41 2621.67 2701.41 2580.37 2704.71 2576.07 2722.41 2553.37",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2738.51 2449.67 2708.01 2489.07 2704.71 2493.37 2672.71 2534.77 2669.41 2538.97 2637.31 2580.37 2634.01 2584.57 2602.01 2625.97 2598.71 2630.27 2566.71 2671.47 2563.41 2671.47 2563.31 2671.37 2561.41 2669.87 2563.31 2667.37 2595.41 2625.97 2598.71 2621.67 2630.71 2580.37 2634.01 2576.07 2666.11 2534.77 2669.41 2530.47 2701.41 2489.07 2704.71 2484.87 2736.81 2443.47 2740.11 2439.17 2740.21 2439.07 2740.21 2439.37 2739.11 2446.47 2738.51 2449.67",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2527.21,2266.17l-31.3,40.4-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-2.1,2.8-1.1-6.9-.1-.1.1-.1,32-41.3,3.3-4.3,32-41.4,3.3-4.3,32.1-41.4,3.3-4.3,28.2-36.4C2523,2266,2525.11,2266.07,2527.21,2266.17Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2461,2260.47l-.4.6-3.3,4.3-32.1,41.4-3.3,4.3-32.1,41.4-3.3,4.3-10.7,13.8-1.1-7.1,8.5-11,3.3-4.3,32-41.4,3.3-4.3,32.1-41.4,1.1-1.4c1.6.2,3.3.5,5,.7Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2400,2247.87l-10.2,13.1-3.3,4.3-22.6,29.1-1.1-7.1,20.4-26.3,3.3-4.3,8.2-10.5C2396.41,2246.77,2398.21,2247.37,2400,2247.87Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2795.91,2155.67h-92.3v-28.1h56A37.56,37.56,0,0,1,2795.91,2155.67Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2760.21,2127.57a58.83,58.83,0,0,0-56.1,43.1l-21.3,77.3c-3,.5-6.1,1-9.2,1.4l-6.1.9c-18.8,2.6-39.3,4.5-61,5.6l-6.5.3c-11.9.5-24.2.8-36.7.8-9.6,0-19.1-.2-28.4-.5l-6.9-.3c-.9,0-1.8-.1-2.7-.1l23.6-85.4a58.69,58.69,0,0,1,56.7-43.1Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "LAMP"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2697.01 461.27 2933.11 1133.67 2068.51 1133.67 2298.31 461.27 2697.01 461.27",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2499.51,381.17a50.7,50.7,0,0,1,50.7-50.7h29.3a50.7,50.7,0,0,1,50.7,50.7v656.1",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2698.31,1112.27v20.3h-213.8v-20.3a75.07,75.07,0,0,1,75-75h63.7c1,0,2.1,0,3.1.1A74.94,74.94,0,0,1,2698.31,1112.27Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2745.81,464.07h-494.7v-15.5a67.11,67.11,0,0,1,67.1-67.1h360.5a67.11,67.11,0,0,1,67.1,67.1v15.5Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2745.81,
    y1: 451.67,
    x2: 2251.11,
    y2: 451.67,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2694.11,464.07c0,17.7-11,32.1-24.7,32.1h-346.2c-13.6,0-24.7-14.4-24.7-32.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2630.21,1056.87c0,32.1-29.3,58.2-65.4,58.2-32.5,0-59.5-21.1-64.5-48.8a75,75,0,0,1,59.2-29h63.7c1,0,2.1,0,3.1.1A49.56,49.56,0,0,1,2630.21,1056.87Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2566.61,1023.57V1055c0,6.4-5.9,11.6-13.1,11.6s-13.1-5.2-13.1-11.6v-31.4h.2c1.2,5.5,6.5,9.7,12.8,9.7s11.6-4.2,12.8-9.7Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2563.81,1022.47a14.92,14.92,0,0,1-.2,2.1,10.4,10.4,0,0,1-10.2,8.7,10.56,10.56,0,0,1-10.2-8.7,14.92,14.92,0,0,1-.2-2.1,10.55,10.55,0,0,1,10.4-10.8A10.68,10.68,0,0,1,2563.81,1022.47Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "BOOKS"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2189.01,
    y: 677.87,
    width: 34.2,
    height: 455.8,
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2174.71,1133.67h-58.6a11.18,11.18,0,0,1-11.2-11.2V783.67a11.18,11.18,0,0,1,11.2-11.2h58.6a11.18,11.18,0,0,1,11.2,11.2v338.8A11.18,11.18,0,0,1,2174.71,1133.67Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2363.21,1126.37h-67.3a10.18,10.18,0,0,1-10-8.3l-60.4-313.8a10.17,10.17,0,0,1,10-12.1h67.3a10.18,10.18,0,0,1,10,8.3l60.4,313.8A10.17,10.17,0,0,1,2363.21,1126.37Z",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2091.51,1133.67h-317a13.4,13.4,0,0,1-13.4-13.4v-64.9a13.4,13.4,0,0,1,13.4-13.4h317a13.4,13.4,0,0,1,13.4,13.4v64.9A13.4,13.4,0,0,1,2091.51,1133.67Z",
    fill: "#fe5244"
  })), /*#__PURE__*/React.createElement("g", {
    id: "NOTES"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M904.41,21.27v206.8a73.45,73.45,0,0,1-73.4,73.4H601.71a73.38,73.38,0,0,0,73.4-73.4V21.27Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780.01,
    y: 1.27,
    width: 18.5,
    height: 44.1,
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.71,99.87a10.91,10.91,0,0,1-7.3-2.9l-7.7-6.8a5.87,5.87,0,0,0-8,0l-7.3,6.5a10.9,10.9,0,0,1-14.7,0l-6.7-5.9a5.87,5.87,0,0,0-8,0l-6.2,5.5a10.9,10.9,0,0,1-14.7,0l-5.1-4.5a5.87,5.87,0,0,0-8,0l-5.5,4.9a10.9,10.9,0,0,1-14.7,0l-5.1-4.5a5.87,5.87,0,0,0-8,0,2.48,2.48,0,1,1-3.3-3.7,10.9,10.9,0,0,1,14.7,0l5.1,4.5a5.87,5.87,0,0,0,8,0l5.5-4.9a10.9,10.9,0,0,1,14.7,0l5.1,4.5a5.87,5.87,0,0,0,8,0l6.2-5.5a10.9,10.9,0,0,1,14.7,0l6.7,5.9a5.87,5.87,0,0,0,8,0l7.3-6.5a10.9,10.9,0,0,1,14.7,0l7.7,6.8a5.87,5.87,0,0,0,8,0l8-7.1a10.9,10.9,0,0,1,14.7,0,2.48,2.48,0,0,1-3.3,3.7,5.87,5.87,0,0,0-8,0l-8,7.1A12,12,0,0,1,837.71,99.87Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.71,141a10.91,10.91,0,0,1-7.3-2.9l-7.7-6.8a5.87,5.87,0,0,0-8,0l-7.3,6.5a10.9,10.9,0,0,1-14.7,0l-6.7-5.9a5.87,5.87,0,0,0-8,0l-6.2,5.5a10.9,10.9,0,0,1-14.7,0l-5.1-4.5a5.87,5.87,0,0,0-8,0l-5.5,4.9a10.9,10.9,0,0,1-14.7,0l-5.1-4.5a5.87,5.87,0,0,0-8,0,2.48,2.48,0,0,1-3.3-3.7,10.9,10.9,0,0,1,14.7,0l5.1,4.5a5.87,5.87,0,0,0,8,0l5.5-4.9a10.9,10.9,0,0,1,14.7,0l5.1,4.5a5.87,5.87,0,0,0,8,0l6.2-5.5a10.9,10.9,0,0,1,14.7,0l6.7,5.9a5.87,5.87,0,0,0,8,0l7.3-6.5a10.9,10.9,0,0,1,14.7,0l7.7,6.8a5.87,5.87,0,0,0,8,0l8-7.1a10.9,10.9,0,0,1,14.7,0,2.48,2.48,0,0,1-3.3,3.7,5.87,5.87,0,0,0-8,0l-8,7.1A11.46,11.46,0,0,1,837.71,141Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.71,182.07a10.91,10.91,0,0,1-7.3-2.9l-7.7-6.8a5.87,5.87,0,0,0-8,0l-7.3,6.5a10.9,10.9,0,0,1-14.7,0L786,173a5.87,5.87,0,0,0-8,0l-6.2,5.5a10.9,10.9,0,0,1-14.7,0L752,174a5.87,5.87,0,0,0-8,0l-5.5,4.9a10.9,10.9,0,0,1-14.7,0l-5.1-4.5a5.87,5.87,0,0,0-8,0,2.48,2.48,0,0,1-3.3-3.7,10.9,10.9,0,0,1,14.7,0l5.1,4.5a5.87,5.87,0,0,0,8,0l5.5-4.9a10.9,10.9,0,0,1,14.7,0l5.1,4.5a5.87,5.87,0,0,0,8,0l6.2-5.5a10.9,10.9,0,0,1,14.7,0l6.7,5.9a5.87,5.87,0,0,0,8,0l7.3-6.5a10.9,10.9,0,0,1,14.7,0l7.7,6.8a5.87,5.87,0,0,0,8,0l8-7.1a10.9,10.9,0,0,1,14.7,0,2.48,2.48,0,0,1-3.3,3.7,5.87,5.87,0,0,0-8,0l-8,7.1A11.46,11.46,0,0,1,837.71,182.07Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.71,223.27a10.91,10.91,0,0,1-7.3-2.9l-7.7-6.8a5.87,5.87,0,0,0-8,0l-7.3,6.5a10.9,10.9,0,0,1-14.7,0l-6.7-5.9a5.87,5.87,0,0,0-8,0l-6.2,5.5a10.9,10.9,0,0,1-14.7,0l-5.1-4.5a5.87,5.87,0,0,0-8,0l-5.5,4.9a10.9,10.9,0,0,1-14.7,0l-5.1-4.5a5.87,5.87,0,0,0-8,0,2.48,2.48,0,1,1-3.3-3.7,10.9,10.9,0,0,1,14.7,0l5.1,4.5a5.87,5.87,0,0,0,8,0l5.5-4.9a10.9,10.9,0,0,1,14.7,0l5.1,4.5a5.87,5.87,0,0,0,8,0l6.2-5.5a10.9,10.9,0,0,1,14.7,0l6.7,5.9a5.87,5.87,0,0,0,8,0l7.3-6.5a10.9,10.9,0,0,1,14.7,0l7.7,6.8a5.87,5.87,0,0,0,8,0l8-7.1a10.9,10.9,0,0,1,14.7,0,2.48,2.48,0,1,1-3.3,3.7,5.87,5.87,0,0,0-8,0l-8,7.1A12,12,0,0,1,837.71,223.27Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 980.11,
    y: 21.27,
    width: 160.4,
    height: 160.4,
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.1,
    y: 15.09,
    width: 54.5,
    height: 18.5,
    transform: "translate(204.35 626.66) rotate(-38.94)",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1124.2,
    y: -2.93,
    width: 18.5,
    height: 54.5,
    transform: "translate(402.08 890.58) rotate(-51.06)",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1009.31,
    y: 59.27,
    width: 97.3,
    height: 6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1009.31,
    y: 85.17,
    width: 97.3,
    height: 6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1009.31,
    y: 111.17,
    width: 97.3,
    height: 6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1009.31,
    y: 137.07,
    width: 97.3,
    height: 6,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "COMPUTER"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1753.61 1133.67 1379.71 1133.67 1452.11 973.67 1462.71 950.17 1670.61 950.17 1699.81 1014.67 1753.61 1133.67",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1699.81 1014.67 1452.11 973.67 1462.71 950.17 1670.61 950.17 1699.81 1014.67",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2007.31,950.17h-880.1a58.4,58.4,0,0,1-58.4-58.4V317.27a58.4,58.4,0,0,1,58.4-58.4h880.1a58.4,58.4,0,0,1,58.4,58.4v574.4A58.49,58.49,0,0,1,2007.31,950.17Z",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.61,909.57h-352.8a31.07,31.07,0,0,1-31.1-31.1v-42.7a31.07,31.07,0,0,1,31.1-31.1h352.8a31.07,31.07,0,0,1,31.1,31.1v42.7A31.13,31.13,0,0,1,1743.61,909.57Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651,881.07h-23.8a10.71,10.71,0,0,1-10.7-10.7v-18.6a10.71,10.71,0,0,1,10.7-10.7H1651a10.71,10.71,0,0,1,10.7,10.7v18.6A10.71,10.71,0,0,1,1651,881.07Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681.31,878l-8.8-5.6a8.4,8.4,0,0,1-3.9-7.1v-8.4a8.4,8.4,0,0,1,3.9-7.1l8.8-5.6a3.13,3.13,0,0,1,4.8,2.6v28.5A3.13,3.13,0,0,1,1681.31,878Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560.81,871.67h-2.2a15.83,15.83,0,0,1-15.8-15.8v-9.3a1.54,1.54,0,0,1,1.5-1.5H1575a1.54,1.54,0,0,1,1.5,1.5v9.3A15.68,15.68,0,0,1,1560.81,871.67Zm-15-23.6v7.8a12.82,12.82,0,0,0,12.8,12.8h2.2a12.82,12.82,0,0,0,12.8-12.8v-7.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1559.71,889a1.54,1.54,0,0,1-1.5-1.5v-11.3a1.5,1.5,0,0,1,3,0v11.3A1.54,1.54,0,0,1,1559.71,889Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1567.61,889h-15.7a1.5,1.5,0,0,1,0-3h15.7a1.5,1.5,0,0,1,0,3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560.41,864.67H1559a9,9,0,0,1-9-9v-18.2a9,9,0,0,1,9-9h1.4a9,9,0,0,1,9,9v18.2A9,9,0,0,1,1560.41,864.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.41,853.37l-.1.1c-1.9,2.3-1.3,5.8,1.2,7.9l9.2,7.4a5.76,5.76,0,0,0,8-.5l.1-.1a5.54,5.54,0,0,1,7.9-.3l8.3,7.5c2.6,2.4,2.6,6.4,0,8.2-8.7,6.1-20,3.9-29.3-3.6l-14-11.3c-9.3-7.6-13.8-18.2-9.7-28,1.3-3,5.2-3.8,8-1.7l9.1,6.6A5.66,5.66,0,0,1,1468.41,853.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492.81,859.17a1.52,1.52,0,0,1-1.5-1.4,13.08,13.08,0,0,0-13.9-12.2,1.62,1.62,0,0,1-1.6-1.4,1.54,1.54,0,0,1,1.4-1.6,16.1,16.1,0,0,1,17.1,15,1.49,1.49,0,0,1-1.5,1.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1502.21,857.67a1.52,1.52,0,0,1-1.5-1.4,22.75,22.75,0,0,0-24.1-21.2,1.62,1.62,0,0,1-1.6-1.4,1.54,1.54,0,0,1,1.4-1.6,25.91,25.91,0,0,1,18.6,6.3,25.54,25.54,0,0,1,8.7,17.6,1.48,1.48,0,0,1-1.5,1.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1840.41,
    cy: 302.57,
    r: 10.4,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1882.91,
    cy: 302.57,
    r: 10.4,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1925.51,
    cy: 302.57,
    r: 10.4,
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.21,779.07h-313.4a17.31,17.31,0,0,1-17.3-17.3V594a17.31,17.31,0,0,1,17.3-17.3h313.4a17.31,17.31,0,0,1,17.3,17.3v167.8A17.31,17.31,0,0,1,1530.21,779.07Z",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925.51,779.07h-313.4a17.31,17.31,0,0,1-17.3-17.3V594a17.31,17.31,0,0,1,17.3-17.3h313.4a17.31,17.31,0,0,1,17.3,17.3v167.8A17.31,17.31,0,0,1,1925.51,779.07Z",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1866.31,778.57h-204.8a112.78,112.78,0,0,1,87.7-41.9h29.4A113.09,113.09,0,0,1,1866.31,778.57Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.51,736.77a30.79,30.79,0,0,1-57.3,11.1,112.81,112.81,0,0,1,48.9-11.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1818,743.77a30.79,30.79,0,0,1-59.2-7.1h19.9A114.1,114.1,0,0,1,1818,743.77Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.51,692.17v45.4c0,7.1-14.2,12.8-31.6,12.8a89.6,89.6,0,0,1-9.2-.5c-13-1.6-22.4-6.5-22.4-12.3v-45.4Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.31,701.47c0,19.7-17.2,43.6-36.6,48.3-13-1.6-22.4-6.5-22.4-12.3v-45.4h58Z",
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1811.71,686.37v1.1a14,14,0,0,1-14,14h-13.4a38.31,38.31,0,0,1-34.8,22.1h-2.6a31.07,31.07,0,0,1-31.1-31.1v-32.1c19.9,1.3,45.2-16.1,45.2-16.1,8.3,32.1,32,31.7,43,29.6A14.19,14.19,0,0,1,1811.71,686.37Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792,691.27a1.54,1.54,0,0,1-1.5-1.5,11.61,11.61,0,0,1,11.6-11.6,1.5,1.5,0,0,1,0,3,8.6,8.6,0,0,0-8.6,8.6A1.54,1.54,0,0,1,1792,691.27Z",
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.51,701.47h2.2a14,14,0,0,0,14-14v-1.1a13.89,13.89,0,0,0-7.7-12.5,44.84,44.84,0,0,1-11.5.7c-11.4-.9-25.5-7.1-31.5-30.3,0,0-25.3,17.4-45.2,16.1a22.73,22.73,0,0,1-10.3-2.9c-16.5-9.4,23.4-53.4,69.2-46.8,36.6,5.3,35.8,49.1,35.1,59.5a48.86,48.86,0,0,1,5.4-.3c26.8,0,48.5,20.6,48.5,46.1,0,16.6-9.2,31.2-23.1,39.3a112,112,0,0,0-45.1-17.3Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1736,692.37a.75.75,0,0,1-.5-.1,1.48,1.48,0,0,1-.9-1.9,21.48,21.48,0,0,0-2-16.9c-4.3-7.5-13.8-6.2-14.2-6.1a1.51,1.51,0,1,1-.4-3c.5-.1,11.9-1.7,17.3,7.6a24.16,24.16,0,0,1,2.2,19.4A1.88,1.88,0,0,1,1736,692.37Z",
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.11,673.37a1.61,1.61,0,0,1-.9-.3c-8.7-6.7-20.3-5.9-20.4-5.9a1.5,1.5,0,0,1-.2-3c.5,0,12.8-.9,22.4,6.5a1.46,1.46,0,0,1,.3,2.1A1.73,1.73,0,0,1,1770.11,673.37Z",
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730.81,695.77s2.4,15.8,18.7.4C1749.51,696.17,1738.11,697.67,1730.81,695.77Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1755.91,
    cy: 677.77,
    rx: 2.1,
    ry: 4.7,
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1724.71,
    cy: 677.77,
    rx: 1.8,
    ry: 3.9,
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1921.61,549.77h-313.4a17.31,17.31,0,0,1-17.3-17.3V364.67a17.31,17.31,0,0,1,17.3-17.3h313.4a17.31,17.31,0,0,1,17.3,17.3v167.8A17.37,17.37,0,0,1,1921.61,549.77Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1857.81,549.77h-191.3c19.3-25.7,48.8-42.1,81.9-42.1h27.5C1809,507.67,1838.51,524.07,1857.81,549.77Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752,541.17h4.3a33.93,33.93,0,0,0,33.9-33.9v-24.1a.22.22,0,0,0-.2-.2h-62.9a.22.22,0,0,0-.2.2v33.1A25.07,25.07,0,0,0,1752,541.17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727,483v33.8c.9,18.6,47.2,11.3,61.1-33.8Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.51,468.47a14.51,14.51,0,0,1-14.6,14.5h-13.7a34.39,34.39,0,0,1-32.2,22.2h-10.7a26.91,26.91,0,0,1-26.9-26.9v-42c15.4,1.3,28.4-11.1,28.9-11.6-.2.7-8,22.7,9.7,23.9s23.4-11.5,23.6-12c0,.5.1,17.5,14,18.4h7.3C1802,455,1808.51,460.47,1808.51,468.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.91,455h-1.2c-13.9-.9-14-17.8-14-18.4-.2.5-6.1,13.2-23.6,12s-9.9-23.2-9.7-23.9c-.5.4-13.5,12.9-28.9,11.6a25.9,25.9,0,0,1-10.3-3.1c-22.5-12.2-8-37.3,14.1-37.6,17.6-.2,25.1,9.4,25.1,9.4s3.8-19.7,25.4-16.3,17.7,22.5,17.7,22.5,18.1-8.4,28.1,7.1C1822.41,436.47,1804.71,455,1787.91,455Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1728.81,473.27h-.4a1.49,1.49,0,0,1-1.1-1.8c0-.1,2.4-10-1.9-18.1-4.7-8.6-12.8-7.2-13.1-7.2a1.48,1.48,0,0,1-1.7-1.2,1.41,1.41,0,0,1,1.2-1.7,15.89,15.89,0,0,1,16.3,8.7c4.9,9.1,2.3,19.8,2.2,20.2A1.87,1.87,0,0,1,1728.81,473.27Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1734.11,484.87a20.24,20.24,0,0,1-5.4-.7,1.49,1.49,0,1,1,.7-2.9h0c.5.1,11.9,3.1,16.1-5.7a1.5,1.5,0,0,1,2-.7,1.42,1.42,0,0,1,.7,2C1745.31,483.17,1739.21,484.87,1734.11,484.87Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1748.61,
    cy: 456.57,
    rx: 2.1,
    ry: 4.7,
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1717.51,
    cy: 456.57,
    rx: 1.8,
    ry: 3.9,
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.41,474a1.54,1.54,0,0,1-1.5-1.5,11.61,11.61,0,0,1,11.6-11.6,1.5,1.5,0,0,1,0,3,8.6,8.6,0,0,0-8.6,8.6A1.54,1.54,0,0,1,1786.41,474Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526.21,549.77h-313.4a17.31,17.31,0,0,1-17.3-17.3V364.67a17.31,17.31,0,0,1,17.3-17.3h313.4a17.31,17.31,0,0,1,17.3,17.3v167.8A17.24,17.24,0,0,1,1526.21,549.77Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.51,549.77h-194.4c19.6-29.3,49.6-48,83.2-48h28C1400.91,501.77,1430.81,520.47,1450.51,549.77Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.51,549.77h-194.4c.6-.9,1.2-1.7,1.8-2.6a1,1,0,0,1,.4-.5h190.1a1.76,1.76,0,0,0,.4.5C1449.31,548,1449.91,548.87,1450.51,549.77Z",
    fill: "#feb040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.31,538.87h-178c.9-1.1,1.8-2.1,2.7-3.1h172.6C1440.51,536.77,1441.41,537.77,1442.31,538.87Z",
    fill: "#feb040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1431.31,527.47h-156c1.2-1.1,2.4-2.1,3.6-3.1h148.8C1428.91,525.37,1430.11,526.37,1431.31,527.47Z",
    fill: "#feb040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.51,515H1292c1.8-1.1,3.7-2.1,5.6-3.1h111.2C1410.81,512.87,1412.61,513.87,1414.51,515Z",
    fill: "#feb040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.31,464.37v44.7c0,4.6-14.2,8.3-31.6,8.3-17,0-30.9-3.5-31.6-8v-45Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383.91,464.37v1c0,22-27.3,47.2-47,50.1-3.1.5-12.7-1.4-15.7-6.2v-45h62.7Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1401.51,450.27v1a14,14,0,0,1-14,14h-12.1a33.09,33.09,0,0,1-31.9,24.2h-12.9a26,26,0,0,1-26-26v-56.9c24,6.7,66.9.4,66.9.4a44.86,44.86,0,0,0,3.5,29.2h12.6A14.17,14.17,0,0,1,1401.51,450.27Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387,434.47h-11.4c-9.7-16.4-4.2-27.3-4.2-27.3s-42.9,6.2-66.9-.4c-10.9-3-17.9-8.7-15.3-18.8,8.3-32.4,97.7,2.1,103.9,13.8S1387,434.47,1387,434.47Z",
    fill: "#fff",
    stroke: "#feb040",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342.61,465.17a1.28,1.28,0,0,1-1,.4,1.61,1.61,0,0,1-1.1-.5l-1.4-1.5c-4.3,3.8-8.4,5.7-12.2,5.7a3.75,3.75,0,0,1-1.1-.1,9.47,9.47,0,0,1-6.4-3.3,1.5,1.5,0,1,1,2.4-1.8,6.61,6.61,0,0,0,4.4,2.2c3.2.3,6.9-1.4,10.9-4.9l-.8-.9a1.49,1.49,0,0,1,2.2-2l4.2,4.6A1.45,1.45,0,0,1,1342.61,465.17Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.81,435.37a1.5,1.5,0,0,1-1.1-.4,25.4,25.4,0,0,0-20.1-6.9,1.47,1.47,0,1,1-.5-2.9,27.4,27.4,0,0,1,22.7,7.7,1.45,1.45,0,0,1,0,2.1A1.16,1.16,0,0,1,1357.81,435.37Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.71,456.37a.6.6,0,0,1-.4-.1,1.54,1.54,0,0,1-1-1.9c0-.1,3.1-10.3-1.9-19-4.3-7.5-14-5.2-14.1-5.1a1.49,1.49,0,0,1-.7-2.9c4.1-1,13.1-1,17.4,6.6,5.7,9.9,2.4,20.9,2.2,21.4A1.64,1.64,0,0,1,1323.71,456.37Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1312.51,
    cy: 440.77,
    rx: 1.8,
    ry: 3.9,
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1343.61,
    cy: 440.77,
    rx: 2.1,
    ry: 4.7,
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379.71,455.37a1.54,1.54,0,0,1-1.5-1.5,11.82,11.82,0,0,1,11.8-11.8,1.5,1.5,0,0,1,0,3,8.75,8.75,0,0,0-8.8,8.8A1.47,1.47,0,0,1,1379.71,455.37Z",
    fill: "#9a3b82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "WOMAN"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEGS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_LEG",
    "data-name": "RIGHT LEG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1894.51,2341.87c-2.7-.8-4.2-1.2-4.2-1.2l-32.7,107.1-123.1-32.3c-1-.9-1.5-1.4-1.5-1.4s-498.5-390.7-524.7-578.2,182.7-365.4,182.7-365.4,445.3,841.7,500.4,869.2A13.43,13.43,0,0,1,1894.51,2341.87Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.41,1667.37c-15.6,83.5-70.4,252.6-127.1,416.2-84-90.5-151.8-181.8-161-247.8-16.6-118.8,61.3-233.9,120.5-302.1a526.45,526.45,0,0,1,70.4-47.7C1414.71,1515.07,1450.61,1582.47,1496.41,1667.37Z",
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2174.31,2414l-183.1,117.5-53.1-8-48.9,31,15.8,32.4-80.5,51.7c-106.7-97.1-91.6-223.4-91.6-223.4l124.6,32.7,32.7-107.1s111.9,32.7,194.5,29.9C2167.51,2367.87,2174.31,2414,2174.31,2414Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1966.21,2355.07s-7.7-81.4-27-76.3,4.9,86.4,26.6,77.5,43.4-66.6,43.4-66.6",
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1752.01 2531.37 1874.71 2533.27 1935.61 2496.87 1993.41 2506.17 2166.71 2397.97",
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1940.81,
    y1: 2350.47,
    x2: 1929.41,
    y2: 2403.57,
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1965.61,
    y1: 2356.47,
    x2: 1954.21,
    y2: 2409.57,
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1991.51,
    y1: 2360.77,
    x2: 1980.11,
    y2: 2413.87,
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEFT_LEG",
    "data-name": "LEFT LEG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.71,1429.57s73.3,34.2,73.3,159.6c0,121.2-279.8,863.4-279.8,863.4l-86.1,73-87.4-95.7C1011.41,2389.27,888.81,1655.27,1348.71,1429.57Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.91,2667.77l-217.6.2-40.4-35.4-57.9-.3-4.2,35.8-85.3.1c-46.4-144.4,33.6-238.4,33.6-238.4l86.8,95.6,86.7-72.9s75.2,88.2,146.2,130.4C1360,2625.17,1340.91,2667.77,1340.91,2667.77Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.21,2503.87s85.4-55.1,61.1-76.2-73.2,70.5-59.9,77.8,105.4-20.4,105.4-20.4",
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "924.01 2540.47 1026.11 2604.87 1097.01 2604.87 1141.91 2642.57 1342.61 2642.57",
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1173.21,
    y1: 2483.07,
    x2: 1134.81,
    y2: 2521.47,
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1190.81,
    y1: 2501.57,
    x2: 1152.41,
    y2: 2539.97,
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1210.21,
    y1: 2519.17,
    x2: 1171.81,
    y2: 2557.57,
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SKIRT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.71,1429.57c-172.9,84.8-263.5,241.6-311.4,406.3H512.61c-134.3,0-234.4-123.9-206.1-255.2l38.5-178.8h912.3A163.93,163.93,0,0,1,1348.71,1429.57Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "959.11 1600.97 1148.01 1600.57 1120.01 1646.47 959.11 1600.97",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1349.71,1428.57c-86,42.2-151.6,102.2-201.8,172.1H669.21c-86.3,0-150.7-79.3-133.1-163.8l7.3-35",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038,1835.77c19.1-65.7,44.9-130.2,80-189.3l-158.9-45.6",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "BLOUSE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.41,921.57l96.1,377H139.21c-104.4,0-171.6-110.9-123.2-203.4l137.7-263.3a226,226,0,0,1,200.2-121.2h32.5C276,710.57,195.11,814.57,222.41,921.57Z",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329,823.77c56.5,0,103.5-7.5,114.9-18l-175.3,380a194.13,194.13,0,0,1-298.2,69.7l-110.5-89.2s-11,64.7-89.5,81.2v154.2H344.91l-122.5-480.2c-27.3-107,53.6-211.1,164-211.1h297.9a313.92,313.92,0,0,1,250.4,124.9l145.6,193.2,130.8-228.6h0c0,.2-.1.5-.1.7C1211.11,813.87,1264,823.77,1329,823.77Z",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.41,
    y1: 921.57,
    x2: 315.51,
    y2: 1301.57,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860.91,
    y1: 1171.37,
    x2: 777.31,
    y2: 1082.37,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.51,800.17l-2.6,5.6c-11.4,10.6-58.4,18-114.9,18-65,0-117.9-9.9-117.9-23a1.7,1.7,0,0,1,.1-.7c1.8-12.8,54-23.8,117.9-23.8s115.6,11,117.4,23.9Z",
    fill: "#fe5244"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ARM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1498.91,608.17a34.68,34.68,0,0,1-4,16.2,35.87,35.87,0,0,1-11.1,12.5l-2.3,1.6-17.9,95.5a57.3,57.3,0,0,1-25.4,37.7l-24.5,15.6-19.4,12.4-9,21.5a561.67,561.67,0,0,1-56.2,2.7,545.6,545.6,0,0,1-56.9-2.8V673a43.79,43.79,0,0,1,4.1-18.5l32.6-70.2s35.6,8.8,19.2,52.5c-14.9,39.7,19.1,29.5,38.2,22.4,17.1-6.4,91.8-44.4,121-58.3A8.11,8.11,0,0,1,1498.91,608.17Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1467.71,697.67a57.1,57.1,0,0,1-25.4,37.6l-43.9,28",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1474.91,657.17a57.1,57.1,0,0,1-25.4,37.6l-43.9,28",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1478.31,
    y1: 639.57,
    x2: 1407.71,
    y2: 684.37,
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1417.51,784.77l-3.9,2.5-19.4,12.4-9,21.5a561.67,561.67,0,0,1-56.2,2.7,545.6,545.6,0,0,1-56.9-2.8v-41.6a491.7,491.7,0,0,1,56.9-3.1C1364.31,776.27,1395.91,779.57,1417.51,784.77Z",
    fill: "#73325a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HEAD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NECK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M752.21,717.77c-14.5,19.5-68.5,65.4-250.3,65.4-233.9,0-84.2-72.4-84.2-72.4l99.2-165.7,106.4,65.3v52.5a47.91,47.91,0,0,0,47.9,47.9h6.9C702.91,710.67,728.51,711.77,752.21,717.77Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "623.21 610.27 623.21 623.67 417.61 710.67 516.81 544.97 623.21 610.27",
    fill: "#73325a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HEAD-2",
    "data-name": "HEAD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M628.81,616.77h22.6a37.73,37.73,0,0,0,37.7-37.7V453.17H554.21v89A74.6,74.6,0,0,0,628.81,616.77Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.21,571.77c-14.5,0-20.3-10-20.3-10",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 673.11,
    cy: 522.17,
    rx: 4.8,
    ry: 9.3,
    fill: "#73325a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "HAIR",
    d: "M579.91,466.27s111.3,67.2,147.5,8.7c31.8-51.3-109.1-77.7-158.3-77.9-53.5-.2-124.4,23.5-123.2,102.2,1,64.8,3.7,159.6-34.7,143.1-136.6-58.6-258,2.6-258.4,119.2s134.9,127.5,138.3,97.4-84-23.1-72.2,54.8,63.9,175.3,183.1,175.3c144,.1,235.7-189.5,146.6-208.8-68.3-14.8,69.6,117,110.5-20,44-147.5-115-195.8-118.9-284.9S579.91,466.27,579.91,466.27Z",
    fill: "#ffcf2d",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "GLASSES"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 572.11,
    y1: 519.77,
    x2: 651.71,
    y2: 519.77,
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 676.21,
    cy: 522.77,
    rx: 22.6,
    ry: 29,
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "HEADPHONES"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.91,484.07v-84.2a22.9,22.9,0,0,1,22.9-22.9h25a22.9,22.9,0,0,1,22.9,22.9",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554,576.77h-48.1a22.32,22.32,0,0,1-22.3-22.3v-48.1a22.32,22.32,0,0,1,22.3-22.3H554a22.32,22.32,0,0,1,22.3,22.3v48.1A22.38,22.38,0,0,1,554,576.77Z",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.51,560.87H518a18.42,18.42,0,0,1-18.4-18.4V519a18.42,18.42,0,0,1,18.4-18.4h23.5a18.42,18.42,0,0,1,18.4,18.4v23.5A18.35,18.35,0,0,1,541.51,560.87Z",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.81,
    y1: 502.97,
    x2: 509.01,
    y2: 558.57,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.01,
    y1: 501.07,
    x2: 500.81,
    y2: 549.07,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 558.91,
    y1: 512.87,
    x2: 522.71,
    y2: 560.87,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 559.91,
    y1: 530.77,
    x2: 537.21,
    y2: 560.87,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 522.31,
    y1: 501.07,
    x2: 499.71,
    y2: 530.97,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })))), /*#__PURE__*/React.createElement("g", {
    id: "CHAIR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.31,1892.77v55.1a48.23,48.23,0,0,1-48.2,48.2H322.51",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540.41,
    y1: 1893.37,
    x2: 540.41,
    y2: 2398.87,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.61,2561c0-89.5,88.9-162.1,198.5-162.1h49.8c109.6,0,198.5,72.6,198.5,162.1",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.31,1901.07h-726a65.79,65.79,0,0,1-65.8-65.8h809Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.21,
    cy: 2614.57,
    r: 53.6,
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.91,2009.77h107.6a15.88,15.88,0,0,0,15.9-15.9v-1.2a15.88,15.88,0,0,0-15.9-15.9H284.91a15.88,15.88,0,0,0-15.9,15.9v1.2A15.88,15.88,0,0,0,284.91,2009.77Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.51,1837.27h515.1l-172.3-482.8a84.26,84.26,0,0,0-79.3-55.9H114.31a54.34,54.34,0,0,0-51.2,72.6Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,1837.27h447.8l-166.5-466.8a81.33,81.33,0,0,0-76.6-54H76.31",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.51,
    cy: 2614.57,
    r: 53.6,
    fill: "#ffcf2d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImageBg);
export default __webpack_public_path__ + "static/media/homeImageBg.6f836ac4f107d37b142bc67a808b7278.svg";
export { ForwardRef as ReactComponent };